import Select2 from "select2";

(function($) {
    $(function() {
        if ($("select[name='store-list']").length) {
            $("select.store-list").each((i, el) => {
                $(el).prepend("<option></option>");
                $(el).select2({
                    placeholder: "Select a store",
                });
                $(el).val("");
                $(el).trigger("change");

                $(el).on("change", (e) => {
                    if (
                        $(e.currentTarget).val().length &&
                        $(e.currentTarget)
                            .val()
                            .indexOf(window.location.origin) != -1
                    ) {
                        window.location.href = $(e.currentTarget).val();
                    }
                });
            });
        }
    });
})(jQuery);
